import { makeObservable, observable } from 'mobx';

import { DocumentState } from 'app/model/DocumentState';
import { DocumentReference } from 'app/model/DocumentReference';

/**
 * Модель формы данных по подтверждению подписания документов.
 * По сути представляет информацию для работы формы в удобном формате.
 */
export class ConfirmationFormModel {
    @observable
    conditionAgreement: boolean;

    @observable
    documentsState: Map<string, DocumentState>;

    constructor() {
        makeObservable(this);
        this.setDefault();
    }

    /**
     * Инициализирует поля текущего объекта модели на основе переданных данных.
     *
     * @param documents документы для подтверждения заявки
     */
    init(documents: DocumentReference[]) {
        documents.forEach((document) =>
            this.documentsState.set(document.code, DocumentState.DISPLAYED),
        );
    }

    setDefault() {
        this.conditionAgreement = false;
        this.documentsState = new Map<string, DocumentState>();
    }
}
